import {
  PartnerBindingFormValues,
  PartnerBindingFormViolation,
} from 'types/partnerBindingFormTypes';
import { INPUT_PARTNER_CODE_MIN_LENGTH } from 'utils/constants';
import { stringIsEmpty } from 'utils/stringUtils';

export const validatePartnerBindingFormValues = (
  values: PartnerBindingFormValues
): PartnerBindingFormViolation[] => {
  const violations: PartnerBindingFormViolation[] = [];

  if (stringIsEmpty(values.partnerCode)) {
    violations.push({
      name: 'PartnerCodeIsMissing',
    });
  }

  if (values.partnerCode.length < INPUT_PARTNER_CODE_MIN_LENGTH) {
    violations.push({
      name: 'PartnerCodeIsTooShort',
    });
  }

  return violations;
};

export const createPartnerBindingFormViolationLense = (
  violation: PartnerBindingFormViolation
) => ({
  isPartnerCodeViolation() {
    switch (violation.name) {
      case 'PartnerCodeIsMissing':
      case 'PartnerCodeIsTooShort':
        return true;
      default:
        return false;
    }
  },
});
